import styled from "styled-components"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Checkbox, CircularProgress, Typography } from "@mui/material"
import CustomButton from "../../components/custom-button/custom-button.component"
import Box from "@mui/material/Box"

export const Wrapper = styled(SectionWrapper)`
  padding: 2em 0;
  color: #000000;
`

export const Title = styled.h2`
  font-style: normal;
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  line-height: 28px;
  letter-spacing: -0.02em;
  color: #121314;
  margin-bottom: 1em;
`

export const FormWrapper = styled.div`
  max-width: 750px;
  margin: auto;

  .MuiOutlinedInput-input {
    color: black;
  }
`
export const Input = styled.input`
  background: rgba(0, 0, 0, 0.05);
  border: 0.5px solid rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  padding: 1em;
`

export const InputWrapper = styled.div`
  padding: 0.5em 0;
  display: flex;
  flex-direction: column;

  input,
  textarea {
    padding: 1em !important;
    background-color: rgba(0, 0, 0, 0.1);
    border: 0.5px solid rgba(0, 0, 0, 0.25);
    border: unset;
    border-radius: 2px;
    color: #000000;
  }
`

export const Label = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #191b1d;
  padding-bottom: 0.5em;
`

export const PositionsTitle = styled.div`
  padding: 1em 0;
`
export const Line = styled.div`
  height: 1px;
  background: rgba(25, 27, 29, 0.75);
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const ListWrapper = styled.div`
  ul {
    margin: 0;
  }
`

export const CustomCheckbox = styled(Checkbox)`
  .Mui-checked {
    color: ${({ theme }) => theme.palette.tertiary.main};
  }
`

export const CheckboxLabel = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`

export const TextArea = styled.textarea`
  width: 100%;
`

export const TextAreaWrapper = styled.div`
  padding: 0 15px;
`

export const FileInput = styled.input`
  background: #f3f3f3;
  border-radius: 5px;
  outline: none;
  width: 100%;

  ::-webkit-file-upload-button {
    background-color: ${({ theme }) => theme.palette.tertiary.main};
    padding: 1em;
    border: none;
    cursor: pointer;
    font-weight: 600;
    font-size: ${({ theme }) => theme.typography.pxToRem(13)};
    line-height: 15px;
    letter-spacing: -0.02em;
    color: #ffffff;
  }
`

export const TypeText = styled.span`
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: 24px;
  letter-spacing: -0.5px;
`

export const InfoWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`

export const GridWrapper = styled.div`
  padding: 1em 0;
`

export const PrivacyText = styled(Typography)`
  padding: 1em 0;
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  line-height: 24px;
  letter-spacing: -0.5px;

  p {
    margin: unset;
  }
`

export const Button = styled(CustomButton)`
  margin: 2em auto;
  max-width: 600px;
  width: 100%;
`

export const FormSpinner = styled(Box)`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  //background-color: rgba(0,0,0,0.1);
  background-color: rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

export const CustomSpinner = styled(CircularProgress)`
  color: ${({ theme }) =>
    theme.palette ? theme.palette.secondary.main : `black`};
  width: 60px !important;
  height: 60px !important;
`

export const SuccessMessage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-size: 1.5rem;
    text-align: center;
  }
`
